import { IApplicationState } from '../../../types/redux';

export function selectBaseUrl(state: IApplicationState): string {
  const {
    filters: {
      meta: { url },
    },
  } = state;

  return url;
}
